// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'project-checklist.page.title': 'Project Checklists',
    'project-checklist.page.archive.title': 'Archived Checklists',
    'project-checklist.page.bin.title': 'Binned Checklists',
    'project-checklist.page.search_results': 'Search Results',
    'project-checklist.page.create.title': 'Create New Checklist',
    'project-checklist.page.search.title': 'Find Checklists',
    'project-checklist.page.edit.title': 'Edit Checklist',
    'project-checklist.page.view.title': 'View Checklist',
    'project-checklist.page.all': 'All',

    'project-checklist.button.cancel': 'Cancel',
    'project-checklist.button.select': 'Select',
    'project-checklist.button.find': 'Find Checklists',
    'project-checklist.button.search': 'Apply',
    'project-checklist.button.create': 'Create Checklist',
    'project-checklist.button.new': 'New Checklist',
    'project-checklist.button.save': 'Save Changes',
    'project-checklist.button.archive': 'Archive',
    'project-checklist.button.bin': 'Bin',
    'project-checklist.button.empty': 'Empty Bin',
    'project-checklist.button.delete': 'Permanently Delete',
    'project-checklist.button.edit': 'Edit',
    'project-checklist.button.restore': 'Restore',
    'project-checklist.button.reset': 'Reset',

    'project-checklist.placeholder.search': 'Search checklists',

    'project-checklist.link.create_first_project_checklist': 'Click here to create your first checklist',
    'project-checklist.link.project_checklists': ' Return to Checklists',
    'project-checklist.link.archive': 'Archived Checklists',
    'project-checklist.link.bin': 'Binned Checklists',
    'project-checklist.link.retry': 'Click here to retry',

    'project-checklist.checkbox.all': 'Check All',
    'project-checklist.checkbox.actions_label': 'with selected',

    'project-checklist.label.project_name': 'Project',

    'project-checklist.label.title': 'Title',

    'project-checklist.label.description': 'Description',

    'project-checklist.label.from__due_date': 'From due date',
    'project-checklist.label.to__due_date': 'To due date',
    'project-checklist.label.due_date': 'Due Date',

    'project-checklist.label.project_checklist_status': 'Project Checklist Status',

    'project-checklist.sort.field_label': 'Field',
    'project-checklist.sort.direction_label': 'Direction',
    'project-checklist.sort.direction_ascending': 'Ascending',
    'project-checklist.sort.direction_descending': 'Descending',

    'project-checklist.modal.title.project_checklist_archive': 'Archive Checklist',
    'project-checklist.modal.title.project_checklist_bin': 'Bin Checklist',
    'project-checklist.modal.title.project_checklist_bin_empty': 'Delete All Binned Checklists',
    'project-checklist.modal.title.project_checklist_delete_permanently': 'Delete Checklist',
    'project-checklist.modal.title.project_checklist_restore': 'Restore Checklist',

    'project-checklist.modal.message.project_checklist_archive': 'Are you sure that you want to move this project checklist to the archive ? | Are you sure that you want to move these project checklists to the archive ?',
    'project-checklist.modal.message.project_checklist_bin': 'Are you sure that you want to move this project checklist to the bin ? | Are you sure that you want to move these project checklists to the bin ?',
    'project-checklist.modal.message.project_checklist_bin_empty': 'Are you sure that you want to permanently delete all binned project checklists? This action cannot be undone!',
    'project-checklist.modal.message.project_checklist_delete_permanently':
        'Are you sure that you want to permanently delete this project checklist? This action cannot be undone. | Are you sure that you want to permanently delete these project checklists? This action cannot be undone.',
    'project-checklist.modal.message.project_checklist_restore': 'Are you sure that you want to restore this project checklist? | Are you sure that you want to restore these project checklists?',

    'project-checklist.success.message.project_checklist_created': 'Your project checklist has been created',
    'project-checklist.success.message.project_checklist_updated': 'Your project checklist has been updated',
    'project-checklist.success.message.project_checklist_restored': 'Your project checklist has been restored | All selected project checklists were restored',
    'project-checklist.success.message.project_checklist_deleted': 'Your project checklist has been permanently deleted | All selected project checklists were permanently deleted',
    'project-checklist.success.message.archived_project_checklists': 'Your project checklist was moved to the archive | All selected project checklists were moved to the archive',
    'project-checklist.success.message.binned_project_checklists': 'Your project checklist was moved to the bin | All selected project checklists were moved to the bin',
    'project-checklist.success.message.project_checklist_bin_emptied': 'All binned project checklists were permanently deleted!',

    'project-checklist.error.message.archived_project_checklists': 'This project checklist was already moved to the archive | These project checklists were already moved to the archive',
    'project-checklist.error.message.binned_project_checklists': 'This project checklist was already moved to the bin | These project checklists were already moved to the bin',
    'project-checklist.error.message.project_checklist_bin_emptied': 'All binned project checklists were already deleted',
    'project-checklist.error.message.project_checklist_deleted': 'This project checklist was already permanently deleted | These project checklists were already permanently deleted',
    'project-checklist.error.message.project_checklist_restored': 'This project checklist was already restored | These project checklists were already restored',
    'project-checklist.error.message.error_loading_page': 'Sorry, there was an error loading project checklist.| Sorry, there was an error loading project checklists.',

    'project-checklist.message.search.no_archived_project_checklists': "You don't have any archived project checklists.",
    'project-checklist.message.search.no_binned_project_checklists': "You don't have any binned project checklists.",
};
